export default __webpack_public_path__ + "597fc179335010bfb186a0fa414f89bb.svg";